export default __webpack_public_path__ + "static/media/CarImages.RioGallery4.0d0dac2e.jpg";